import React from "react"
import type { Web3FundManagementCardSection } from "@/common/data/Products"
import { useTranslation } from "next-i18next"
import defiKLine from "@/common/assets/image/solutions/web3-fund-management/defi-k-line.svg"
import money from "@/common/assets/image/solutions/web3-fund-management/money.svg"
import tether from "@/common/assets/image/solutions/web3-fund-management/tether.svg"
import shoppingStore from "@/common/assets/image/solutions/web3-fund-management/shopping-store.svg"

import Card, { CardData } from "./Card"

export interface Web3FundManagementCardsProps {
  cardName: any
  type: Web3FundManagementCardSection
}

export function Web3FundManagementCard({
  cardName,
  type
}: Web3FundManagementCardsProps) {
  const { t } = useTranslation(["web3FundManagement"])
  let data: CardData = {}
  switch (type) {
    case "defiKLine":
      data = {
        icon: defiKLine,
        wide: false,
        backgroundType: "light",
        title: t("Web3FundManagementCards.defiKLine.title"),
        slogan: t("Web3FundManagementCards.defiKLine.slogan"),
        description: t("Web3FundManagementCards.defiKLine.description"),
        button: {
          text: t("Web3FundManagementCards.defiKLine.button"),
          href: "#contact-us"
        }
      }
      break
    case "money":
      data = {
        icon: money,
        wide: false,
        backgroundType: "dark",
        title: t("Web3FundManagementCards.money.title"),
        slogan: t("Web3FundManagementCards.money.slogan"),
        description: t("Web3FundManagementCards.money.description"),
        button: {
          text: t("Web3FundManagementCards.money.button"),
          href: "#contact-us"
        }
      }
      break
    case "shoppingStore":
      data = {
        icon: shoppingStore,
        wide: false,
        backgroundType: "light",
        title: t("Web3FundManagementCards.shoppingStore.title"),
        slogan: t("Web3FundManagementCards.shoppingStore.slogan"),
        description: t("Web3FundManagementCards.shoppingStore.description"),
        button: {
          text: t("Web3FundManagementCards.shoppingStore.button"),
          href: "#contact-us"
        }
      }
      break
    case "tether":
      data = {
        icon: tether,
        wide: false,
        backgroundType: "dark",
        title: t("Web3FundManagementCards.tether.title"),
        slogan: t("Web3FundManagementCards.tether.slogan"),
        description: t("Web3FundManagementCards.tether.description"),
        button: {
          text: t("Web3FundManagementCards.tether.button"),
          href: "#contact-us"
        }
      }
      break
  }
  return <Card cardName={cardName} {...data} />
}
